import { useContext, useMemo } from 'react';
import styled from '@emotion/styled';
import { AuraChatContext } from '@trinity/chat-components/components/BrandInsights/context.js';
import ChatInstance from '@trinity/chat-components/components/Chat/Chat.js';
import { ActiveChatSessionContext, ChatContextItemsContext, ChatSettingsToggleContext } from '@trinity/chat-components/components/Chat/context.js';
import { KolWelcome } from '@trinity/chat-components/components/Chat/Kol.Welcome.js';
import { GetStartedContext, ChatGetStarted } from '@trinity/chat-components/components/Chat.GetStarted/index.js';
import { ChatHeader } from '@trinity/chat-components/components/Chat.Header/index.js';
import { ChatSettings } from '@trinity/chat-components/components/Chat.Screen/Chat.Setting.js';
import { ChatSidebar } from '@trinity/chat-components/components/Chat.Screen/Sidebar.js';
import { AppThemingContext } from '@trinity/chat-components/containers/AppTheming/Context.js';
import { ChatWelcomeScreenContext } from '@trinity/chat-components/containers/BrandInsights/Context.js';
import { useMonitorChatIdentifier } from '@trinity/chat-components/containers/Chat/useMonitorHashChatIdentifier.js';
import chatBackgroundImg from '@trinity/chat-components/static/images/chat-background.png';
import { isBrandInsightsContext } from '@trinity/chat';
import { ChatScreenContainer } from './Container';

const BrandInsightsChatScreen = () => {

  const [getStarted, dismissGetStarted] = useContext(GetStartedContext);
  const { dismiss, enabled, visible } = useContext(ChatWelcomeScreenContext);
  const { auraChatStatus } = useContext(AuraChatContext);
  const [settings] = useContext(ChatSettingsToggleContext);
  const { theme } = useContext(AppThemingContext);
  const { context } = useContext(ActiveChatSessionContext);

  const brandInsights = isBrandInsightsContext(context);

  useMonitorChatIdentifier();

  const isLoading = useIsChatLoading();

  const style = theme?.enabled ? {
    backgroundImage: 'none',
    backgroundColor: '#fafafa',
  } : {};

  const showSettings = !!settings;
  const showWelcomeScreen = !showSettings && enabled && visible && !brandInsights;
  const showGetStarted = !showSettings && getStarted && !enabled;
  const showAuraChat = !showSettings && !showWelcomeScreen && !showGetStarted && auraChatStatus;
  const showChat = !showSettings && !showWelcomeScreen && !showGetStarted;

  if (isLoading) {
    return null;
  }

  return (
    <Root>

      <MainChat>
        <ChatSidebar />

        <Wrap style={style}>
          {(!showSettings && !showAuraChat) && <ChatHeader />}

          {showSettings && <ChatSettings />}
          {showWelcomeScreen && <KolWelcome onClick={dismiss} />}
          {showGetStarted && <StyledGetStarted onClick={dismissGetStarted} />}
          {showAuraChat && (
            <iframe src="https://realinsightsauras.trinitylifesciences.com/home/hcp_auras" width="100%" height="100%" allow="microphone" frameBorder="0"></iframe>
          )}
          {showChat && <ChatInstance />}
        </Wrap>
      </MainChat>
    </Root>
  );
};

function useIsChatLoading() {
  const contextItems = useContext(ChatContextItemsContext);
  const chat = useContext(ActiveChatSessionContext);

  return useMemo(() => {
    return !contextItems || contextItems.length === 0 || !chat.context;
  }, [contextItems, chat.context]);
}

export const ChatScreen = () => {

  return (
    <ChatScreenContainer>
      <BrandInsightsChatScreen />
    </ChatScreenContainer>
  );
};

const Root = styled.div({
  height: `calc(100vh - var(--navbar-height))`,
  width: '100%',
});

const Wrap = styled.div({
  boxSizing: 'border-box',
  width: '100%',
  background: `url(${chatBackgroundImg}) no-repeat`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
});

const StyledGetStarted = styled(ChatGetStarted)(({
  marginTop: 30,
}));

const MainChat = styled.div({
  display: 'flex',
  boxSizing: 'border-box',
  width: '100%',
  height: '100%',
  // height: `calc(100% - ${FooterHeight}px)`,
});